// removed by extract-text-webpack-plugin
module.exports = {"siteWidth":"310px","siteHeight":"170px","sitePadding":"8px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app/styles/app-styles.scss
// module id = 208
// module chunks = 0